import { CarrierRef, SourceSystem } from '@rygen/rygen-ui/model';

export type ShipmentId = string;

export class BillingShipmentReference {
  id?: number;
  sourceSystemId?: ShipmentId;
  sourceSystem?: SourceSystem;
  carrier?: CarrierRef;

  constructor(opts?: Partial<BillingShipmentReference>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.sourceSystemId != null) {
      this.sourceSystemId = opts.sourceSystemId;
    }
    if (opts?.sourceSystem != null) {
      this.sourceSystem = opts.sourceSystem;
    }
    if (opts?.carrier != null) {
      this.carrier = new CarrierRef(opts.carrier);
    }
  }
}
